"use client";
import { ManageSearch, PhotoLibrary } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { type AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { type Translationtype } from "utils";
import { useReservationContext } from "../context";

type JumpToReservationActionProps = {
  reservationId: string;
  router: AppRouterInstance;
  t: Translationtype;
  isActive?: boolean;
};

export function JumpToReservationAction({
  reservationId,
  router,
  t,
  isActive,
}: JumpToReservationActionProps) {
  const { setReservationId } = useReservationContext();
  return (
    <div className="flex flex-1 gap-5 justify-center">
      <IconButton
        title={t("Devices.manageReservation")}
        onClick={() => {
          setReservationId(reservationId);
          router.push(`/reservationDetails`);
        }}
        sx={{ color: isActive ? "red" : "" }}
      >
        <ManageSearch />
      </IconButton>
      <IconButton
        title={t("Devices.jumpToGallery")}
        onClick={() => {
          router.push(`/gallery/albums/${reservationId}`);
        }}
      >
        <PhotoLibrary />
      </IconButton>
    </div>
  );
}
